let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c0D2Y")).then(() => parcelRequire('6Y0wG'));